
import * as THREE from "../../libs/three.js/build/three.module.js";
import { Annotation } from "../Annotation.js";
import { Utils } from "../utils.js";
import { CameraMode } from "../defines.js";
import { EventDispatcher } from "../EventDispatcher.js";
import { ShowMode } from "../defines.js";

export class AnnotationTool extends EventDispatcher {
	constructor(viewer) {
		super();

		this.viewer = viewer;
		this.renderer = viewer.renderer;

		this.sg = new THREE.SphereGeometry(0.1);
		this.sm = new THREE.MeshNormalMaterial();
		this.s = new THREE.Mesh(this.sg, this.sm);
	}

	startInsertion(args = {}) {
		let domElement = this.viewer.renderer.domElement;

		let annotation = new Annotation({
			position: [589748.270, 231444.540, 753.675],
			title: "Annotation Title",
			description: `Annotation Description`
		});
		this.dispatchEvent({ type: 'start_inserting_annotation', annotation: annotation });

		const annotations = this.viewer.scene.annotations;
		annotations.add(annotation);

		// 放置期间禁用该 annotation 的 pointer-events：否则跟随鼠标的 label 会不停触发
		// mouseenter -> setHighlighted(true) -> description.fadeIn，导致详情弹框霸屏、
		// 无法看清落点。canvas 上的 mouseup 是 capture 阶段监听，不受此影响。
		annotation.domElement.css('pointer-events', 'none');

		let callbacks = {
			cancel: null,
			finish: null,
		};

		let insertionCallback = (e) => {
			if (e.button === THREE.MOUSE.LEFT) {
				callbacks.finish();
			} else if (e.button === THREE.MOUSE.RIGHT) {
				callbacks.cancel();
			}
		};

		callbacks.cancel = e => {
			annotations.remove(annotation);

			domElement.removeEventListener('mouseup', insertionCallback, true);
		};

		callbacks.finish = e => {
			// 放置完成，恢复 hover 弹详情能力
			// 判空：cancel 分支会 annotations.remove(annotation) 从而 dispose 掉 domElement，
			// 若右键取消后又走到 finish（同一个 insertionCallback），这里会解引用 null
			if (annotation.domElement) {
				annotation.domElement.css('pointer-events', 'auto');
			}
			domElement.removeEventListener('mouseup', insertionCallback, true);
		};

		domElement.addEventListener('mouseup', insertionCallback, true);

		let drag = (e) => {
			let I = Utils.getMouseIntersection(
				e.drag.end,
				e.viewer.scene.getActiveCamera(),
				e.viewer,
				{ pickClipped: true });

			if (I) {
				this.s.position.copy(I.location);

				annotation.position.copy(I.location);
			}
		};

		let drop = (e) => {
			this.viewer.scene.scene.remove(this.s);
			this.s.removeEventListener("drag", drag);
			this.s.removeEventListener("drop", drop);
		};

		this.s.addEventListener('drag', drag);
		this.s.addEventListener('drop', drop);

		this.viewer.scene.scene.add(this.s);
		this.viewer.inputHandler.startDragging(this.s);

		return annotation;
	}

	update() {
		// let camera = this.viewer.scene.getActiveCamera();
		// let domElement = this.renderer.domElement;
		// let measurements = this.viewer.scene.measurements;

		// const renderAreaSize = this.renderer.getSize(new THREE.Vector2());
		// let clientWidth = renderAreaSize.width;
		// let clientHeight = renderAreaSize.height;

	}

	render() {
		//this.viewer.renderer.render(this.scene, this.viewer.scene.getActiveCamera());
	}
};
